import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect, useParams } from 'umi';

import { embedDashboard } from './components/sdk';
import NoPermission from '../components/no-permission';
import Loading from './components/loading';

import { getPresetInfo as getPresetInfo2 } from '@op/services';
import PresetPointFunc from '@op/operationLog/pages/preset';
import './styles/index.less';
import useReportBuryingPoint from '../hooks/useReportBuryingPoint';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import CommonTips from '@/pages/opinion/components/CommonTips';
import TimezoneTips from '@/pages/opinion/components/TimezoneTips';

interface ReportInfoType {
  loading: boolean;
  noReport: boolean;
}

const INIT_REPORT_INFO: ReportInfoType = {
  noReport: false,
  loading: true,
};

function Preset(props: any) {
  const { reportId } = useParams<{
    reportId: string;
  }>();

  const presetRef = useRef<any>(null);

  const [reportInfo, setReportInfo] =
    useState<ReportInfoType>(INIT_REPORT_INFO);
  let presetId = '';

  const { listMenu = [] } = props;

  const getPresetId = () => {
    if (listMenu?.length > 0) {
      for (let index = 0; index < listMenu.length; index += 1) {
        const curMenuItem = listMenu[index];

        if (!(curMenuItem?.opinion_list?.length > 0)) {
          continue;
        }

        for (
          let index1 = 0;
          index1 < curMenuItem.opinion_list?.length;
          index1 += 1
        ) {
          const item = curMenuItem.opinion_list[index1];
          if (
            item?.name_en === decodeURIComponent(reportId) &&
            (item?.type === '3' || curMenuItem?.type === '3')
          ) {
            if (item?.assembly_params?.preset_id) {
              presetId = item.assembly_params.preset_id;
            }
          }
        }
      }
    }
  };

  const setState = (params = {}) => {
    setReportInfo({
      ...INIT_REPORT_INFO,
      ...params,
    });
  };

  function openPresetReport() {
    if (!reportId) {
      return;
    }

    presetRef?.current?.unmount();

    console.log('preset reportId', reportId, presetId);

    if (!presetId) {
      setState({ noReport: true, loading: false });

      presetRef?.current?.unmount();
      return;
    }

    setState({ loading: true });

    if (document.getElementById('preset-iframe-wrap')) {
      getPresetInfo2({ presetId }).then(
        (presetInfo) => {
          const { guest_token, workspace_region, workspace_name } =
            presetInfo || {};

          if (!guest_token) {
            setState({ noReport: true });
            return;
          }

          setState({
            loading: false,
          });

          let fetchNum = 0;

          console.log('embedDashboard', {
            id: presetId,
            supersetDomain: `https://${workspace_name}.${workspace_region}.app.preset.io`,
          });

          embedDashboard({
            id: presetId, // given by the Superset embedding UI
            supersetDomain: `https://${workspace_name}.${workspace_region}.app.preset.io`,
            mountPoint: document.getElementById(
              'preset-iframe-wrap',
            ) as HTMLElement, // any html element that can contain an iframe
            fetchGuestToken: () => {
              console.log('before fetchGuestToken', presetId);
              fetchNum++;

              if (fetchNum === 1) {
                return Promise.resolve(guest_token);
              }
              return getPresetInfo2({ presetId }).then(
                (data) => {
                  // console.log('getPresetInfo', data);
                  return data?.guest_token || '';
                },
                () => {
                  return '';
                },
              );
            },
            dashboardUiConfig: {
              hideTitle: false,
              hideTab: true,
              hideChartControls: false,
            }, // dashboard UI config: hideTitle, hideTab, hideChartControls (optional)
          }).then((preset) => {
            presetRef.current = preset;
          });
        },
        () => {
          presetRef.current && presetRef.current?.unmount();
          setState({ noReport: true });
        },
      );
    }
  }
  useInitBuriedPointInfo({
    buriedPoint: PresetPointFunc(location.pathname),
    triggerPagePoint: false,
  });
  useReportBuryingPoint({ ...props });

  useEffect(() => {
    getPresetId();
    openPresetReport();
  }, [reportId, listMenu]);

  const errorInfo = useMemo(() => {
    // 路径中无reportid
    if (!reportId) {
      return <NoPermission type="error" textCN="未获取到报表信息" />;
    }
    if (reportInfo.loading) {
      return <Loading />;
    }
    // 路径中无reportid
    if (reportInfo.noReport) {
      return <NoPermission type="error" textCN="未获取到报表信息" />;
    }
    return null;
  }, [reportId, reportInfo]);

  return (
    <>
      <CommonTips hasMargin wholeGameInfo={props.wholeGameInfo}></CommonTips>
      <TimezoneTips
        hasMargin
        wholeGameInfo={props.wholeGameInfo}
      ></TimezoneTips>
      <div id="preset-iframe-wrap" key={presetId}></div>
      {errorInfo ? <div id="preset-iframe-tips">{errorInfo}</div> : null}
    </>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    listMenu: opinionCommon.listMenu,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(Preset);
